import biLogger from '@wix/web-bi-logger';
import {
  pageViewSrc10Evid5000,
  ggGeneralActionSrc10Evid5001,
  ggAiStoreCreateMetasiteWithAppsSrc10Evid5004,
} from '@wix/bi-logger-stores-data/v2';
import {
  pageViewSrc10Evid5000Params,
  ggGeneralActionSrc10Evid5001Params,
  ggAiStoreCreateMetasiteWithAppsSrc10Evid5004Params,
} from '@wix/bi-logger-stores-data/v2/types';

const logger = biLogger.factory({}).logger();

const baseParams = {
  flow: 'pod',
};

const stepViewed = (params: Omit<pageViewSrc10Evid5000Params, 'flow'>) => {
  logger.report(pageViewSrc10Evid5000({ ...baseParams, ...params }));
};

const actionClicked = (params: Omit<ggGeneralActionSrc10Evid5001Params, 'flow'>) => {
  logger.report(ggGeneralActionSrc10Evid5001({ ...baseParams, ...params }));
};

const msidCreated = (params: Omit<ggAiStoreCreateMetasiteWithAppsSrc10Evid5004Params, 'flow'>) => {
  logger.report(ggAiStoreCreateMetasiteWithAppsSrc10Evid5004({ ...baseParams, ...params }));
};

export const biEvents = {
  stepViewed,
  actionClicked,
  msidCreated,
};
